import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { NotificationsPageMain } from "./main";
import { NotificationsRoutes } from "./routes";

export const NotificationsPage: FC = () => {
  return (
    <PageContextWrapper entity="notification">
      <NotificationsPageMain />
      <NotificationsRoutes />
    </PageContextWrapper>
  );
};
